/** Only the human bearer/session authority may invalidate the human identity. */
export function isCanonicalAuthRejection(error: any): boolean {
  const headers = error?.response?.headers;
  const challenge = headers?.get?.('www-authenticate') ??
    headers?.['www-authenticate'] ?? headers?.['WWW-Authenticate'];
  return error?.response?.status === 401 && challenge === 'Bearer';
}
